import { useOutletContext } from 'react-router-dom';

import type { TeamDetail } from '../EventTeamDetailPage';

/**
 * Context shape passed from EventTeamDetailPage's <Outlet> down to
 * its tab children. Lives in its own file so the parent component
 * file can stay component-only (fast-refresh friendly).
 */
export interface TeamDetailOutletContext {
  team: TeamDetail;
  eventId: string;
  teamId: string;
}

export function useTeamDetailContext(): TeamDetailOutletContext {
  return useOutletContext<TeamDetailOutletContext>();
}
